import H2 from 'UIComponents/elements/headings/H2';
import { jsx as _jsx } from "react/jsx-runtime";
const CallHighlightTitle = ({
  title
}) => {
  return /*#__PURE__*/_jsx(H2, {
    className: "text-left p-left-6",
    children: title
  });
};
export default CallHighlightTitle;